<template>
    <painel-component :itens="itensOne">
        <div class="filter-position" v-if="btnFilter">
            <button-one class="btn-filter" @click="filterWindow" icon="filter"/>
        </div>

        <form class="mb-4 mt-5">
            <transition name="fade-in-top">
                <row-component v-if="filter">
                    <row-col-component :class-row-col="'col-xxl-6 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12'">
                        <label>Nome:</label>
                        <input-component :type-input="'text'" v-model="formDate.name" :placeholder="'Digite seu nome'"/>
                    </row-col-component>

                    <row-col-component :class-row-col="'col-xxl-2 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12'">
                        <label>CPF:</label>
                        <input-component :type-input="'text'" v-model="formDate.cpf" :placeholder="'000.000.000-00'"
                                         v-mask="'###.###.###-##'"/>
                    </row-col-component>

                    <row-col-component :class-row-col="'col-xxl-2 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12'">
                        <label>Status:</label>
                        <multiselect v-model="formDate.status" :searchable="true" :options="selectInput"
                                     placeholder="Status" :noResultsText="noResultsText"
                                     :noOptionsText="noResultsText"/>
                    </row-col-component>

                    <row-col-component
                            :class-row-col="'col-xxl-2 col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12 mt-0 mt-xxl-4'">
                        <button-one class="me-2" @submit="submit" :icon="'search'"/>
                        <button-float :itens="itensTwo" v-if="buttonCheck.create"/>
                    </row-col-component>
                </row-component>
            </transition>
        </form>

        <loder-send-component :text-title="'Carregando'" v-if="showLoader"/>

        <div v-else>
            <table class="table table-striped">
                <thead>
                <tr>
                    <th scope="col" style="width: 30%">Nome</th>
                    <th scope="col" style="width: 20%">CPF</th>
                    <th scope="col" style="width: 20%">RG</th>
                    <th scope="col" style="width: 15%">Status</th>
                    <th scope="col" style="width: 15%" v-if="buttonCheck.show || buttonCheck.edit">Ações</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(employee, index) in employees.data" :key="index">
                    <td data-label="Nome">
                        <img v-if="employee.photo" :src="employee.photo" class="avatar__image_2" alt="">
                        <img v-else src="@/assets/img/avatar.png" class="avatar__image_2" alt="">
                        {{ employee.name }}
                    </td>
                    <td data-label="CPF">{{ employee.cpf }}</td>
                    <td data-label="CNPJ">{{ employee.rg }}</td>
                    <td data-label="Status">{{ statusString(employee.status) }}</td>
                    <td data-label="Ações" v-if="buttonCheck.show || buttonCheck.edit">
                        <button-show-round :route="'employee-show'" :id-param="employee.id" v-if="buttonCheck.show"/>
                        <button-edit-round :route="'employee-edit'" :id-param="employee.id" v-if="buttonCheck.edit"/>
                    </td>
                </tr>
                </tbody>
            </table>

            <button-pagination :pagination="employees" :offset="3" @paginate="loadItems"/>
        </div>
    </painel-component>
</template>

<script>
import PainelComponent from "@/components/dashboard/PainelComponent";
import ButtonOne from "@/components/buttons/ButtonOne";
import ButtonFloat from "@/components/buttons/ButtonFloat";
import ButtonPagination from "@/components/buttons/ButtonPagination";
import InputComponent from "@/components/form/InputComponent";
import RowComponent from "@/components/row/RowComponent";
import RowColComponent from "@/components/row/RowColComponent";
import ButtonShowRound from "@/components/buttons/ButtonShowRound";
import ButtonEditRound from "@/components/buttons/ButtonEditRound";
import LoderSendComponent from "@/components/LoderSendComponent";
import Multiselect from "@vueform/multiselect";

import {mask} from 'vue-the-mask'
import {useToast} from "vue-toastification";

const toast = useToast();

export default {
    name: "EmployeeSearch",
    components: {
        PainelComponent,
        ButtonOne,
        ButtonFloat,
        ButtonPagination,
        InputComponent,
        RowComponent,
        RowColComponent,
        ButtonShowRound,
        ButtonEditRound,
        LoderSendComponent,
        Multiselect
    },

    directives: {
        mask
    },

    created() {
        this.$store.dispatch('updateNamePage', 'Funcionário')
        this.loadItems(1)
        this.resizeWindow()
        this.checkACL()
    },

    data() {
        return {
            itensOne: {
                title: "Pesquisa",
                icon: "list alternate"
            },

            itensTwo: {
                route: "/employee/create",
                icon: "plus",
            },

            buttonCheck: {
                edit: false,
                create: false,
                show: false
            },

            formDate: {
                name: '',
                status: '',
                photo: ''
            },

            filter: true,
            btnFilter: false,

            showLoader: true,
            searchSubmit: false,
        }
    },

    methods: {
        submit() {
            this.loadItems(1)
            this.searchSubmit = true;
        },

        loadItems(page) {
            this.showLoader = true
            if (!this.searchSubmit) {
                this.$store.dispatch('loadEmployees', {...this.params, page})
                    .then((r) => {
                        this.showLoader = false
                        if (this.searchSubmit) {
                            this.searchSubmit = false;
                            if (r.data.length === 0) {
                                toast.info("Nada foi encontrado com os parâmetros informados!", {timeout: 10000});
                            }
                        }
                    }).catch(() => {
                    this.showLoader = false
                    this.searchSubmit = false;
                });
            }
        },

        async checkACL() {
            this.$store.dispatch('ACLitens', 5)
                .then((r) => {

                    if (r.data.indexOf('employee-search') !== -1) {
                        this.showLoader = false

                        if (r.data.indexOf('employee-search') !== -1) {
                            this.buttonCheck.show = true
                        }

                        if (r.data.indexOf('employee-edit') !== -1) {
                            this.buttonCheck.edit = true
                        }

                        if (r.data.indexOf('employee-create') !== -1) {
                            this.buttonCheck.create = true
                        }

                    } else {
                        this.$router.push({name: 'home'})
                    }
                }).catch(() => {
                this.$router.push({name: 'home'})
            })
        },

        filterWindow() {
            this.filter = !this.filter
        },

        resizeWindow() {
            if (window.innerWidth <= 991) {
                this.filter = false
                this.btnFilter = true
            } else {
                this.filter = true
                this.btnFilter = false
            }
        },

        statusString(value) {
            if (parseInt(value) === 1)
                return 'Ativo'
            return 'Inativo'
        },
    },

    computed: {
        noResultsText() {
            return this.$store.state.var.selectNotSearch;
        },

        selectInput() {
            return this.$store.state.var.selectActiveInactiveSearch;
        },

        employees() {
            return this.$store.state.employee.items
        },

        params() {
            return {
                page: this.employees.current_page,
                name: this.formDate.name,
                status: this.formDate.status,
                cpf: this.formDate.cpf,
            }
        },
    },
}
</script>

<style scoped src="@/assets/css/table-resp.css"></style>
<style scoped>
.avatar__image_2 {
    width: 30px;
    height: 30px;
    object-fit: cover;
    border-radius: 50%;
    margin-right: 10px;
    border: 1px solid #d67c1c;
}
</style>
